import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import * as MechanicDashboardActions from './mechanic-dashboard.actions';
import * as MechanicDashboardSelector from './mechanic-dashboard.selectors';

@Injectable({
  providedIn: 'root',
})
export class MechanicDashboardFacade {
  constructor(private store: Store<TMachineMaintenanceState>) {}

  fetchMechanicDashboardInfo() {
    this.store.dispatch(new MechanicDashboardActions.GetMechanicDashboardInfo());
  }

  getMechanicDashboardInfo() {
    return this.store.pipe(select(MechanicDashboardSelector.getMechanicDashboardInfo));
  }
}

export type TGetMechaninDashboardInfo = ReturnType<MechanicDashboardFacade['getMechanicDashboardInfo']>;
